export { Icon, type IconProps } from './styled/icon'
